var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      fill: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      flexShrink: 0
    },
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    weight: "regular",
    fill: "#FFFCF5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z",
    fill: "#FFFCF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe);
export default __webpack_public_path__ + "static/media/re.c4612af50649d1528676f59907fa86d3.svg";
export { ForwardRef as ReactComponent };